// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409EFF","subMenuActiveText":"#ccc","menuBg":"#fff","menuHover":"#ededf3","subMenuBg":"#fff","subMenuHover":"#e0e0e4","sideBarWidth":"210px"};